import React, { useState, useContext } from 'react'
import FilterPopover from '../FilterPopover/FilterPopover'
import AllFilters from '../AllFilters/AllFilters'
import myContext from '../context/context'
import ClearFilters from '../ClearFilters/ClearFilters'
import { isFilterApplied } from '../../Utility/Utility.js'
import ProspectingFilter from '../ProspectingFilter/ProspectingFilter'
import PolygonFilter from '../PolygonFilter/PolygonFilter'

function FiltersComponent() {
  // const [searchFields, setSearchFields] = useState(getSearchFields)

  // function updateSearchFields(newSearchFields) {
  //   setSearchFields(newSearchFields)
  // }
  const { searchCriteria, searchResult, preSearchCriteria } = useContext(myContext)
  const [showMore, setshowMore] = useState(false)

  const showBadge = item => {
    let returnVal = false
    if (searchCriteria[item].length > 0) {
      returnVal = true
    }

    return returnVal
  }

  return (
    <>
      <div className="flex flex-wrap gap-4">
        {/* searchCriteria.subjectProperty.propertyLocation is for POI as landmark. This is coming from OV where user has saved landmark  */}
        {searchCriteria.prospecting.length > 0 || (searchCriteria.subjectProperty.propertyLocation && searchCriteria.subjectProperty.omniViewPropertyId === '') ?
          <div data-testid="test-filterComp-ProspectingFilter">
            <ProspectingFilter />
          </div>
          : null}
        {searchCriteria.polygon && searchCriteria.polygon.points.length > 0 ?
          <div data-testid="test-filterComp-PolygonFilter">
            <PolygonFilter />
          </div>
          : null}
        {searchCriteria.distanceFields.length > 0 ?
          <div>
            <FilterPopover name="Distance" filterName="DistanceFilter" startIcon="NearMeIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div>
          : null}
        <div data-testid="test-div-Type-popover">
          <FilterPopover name="Type" filterName="PropertyTypeFilter" startIcon="HomeIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
        </div>
        <div data-testid="test-div-features-popover">
          <FilterPopover name="Features" filterName="FeaturesFilter" startIcon="ListAltIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
        </div>
        {/* <div>
          <FilterPopover name="Listings" filterName="ListingStatusFilter" startIcon="ApartmentIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
        </div> */}

        {showMore || showBadge('tenantInfoFields') ?
          <div>
            <FilterPopover name="Tenant Info" filterName="TenantInfoFilter" startIcon="PersonIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div> : null}

        {showMore || showBadge('salesFields') ?
          <div>
            <FilterPopover name="Sales" filterName="SalesFilter" startIcon="MonetizationOnIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div> : null}

        {(showMore || showBadge('locationFields')) && searchResult.property.length !== 0 && preSearchCriteria.searchType !== 'prospecting' ?
          <div>
            <FilterPopover name="Location" filterName="NearByLocationFiltersPopOver" startIcon="LocationOnIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div> : null}

        {showMore || showBadge('listingStatusFields') ?
          <div data-testid="test-div-Listings-popover">
            <FilterPopover name="Listings" filterName="ListingStatusFilter" startIcon="ApartmentIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div> : null}

        {(showMore || showBadge('loanFields')) && preSearchCriteria.searchType === 'prospecting' ?
          <div>
            <FilterPopover name="Loan" filterName="LoanFilter" startIcon="AccountBalanceIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div> : null}

        {(showMore || showBadge('accountFields')) && preSearchCriteria.searchType === 'prospecting' ?
          <div>
            <FilterPopover name="Account" filterName="AccountFilter" startIcon="WorkIcon" btnVariant="outlined" endIcon="ArrowDropDownIcon" />
          </div> : null}

        <div>
          <AllFilters />
        </div>
        <div>
          <div data-testid="test-show-more" onClick={() => setshowMore(!showMore)} className="badge rounded-pill px-5 mr-3 mb-4 cursor-pointer py-3 bg-gray-15">
            <label className="text-primary">
              {showMore ? 'show less' : 'show more'}
            </label>
          </div>
        </div>
        {isFilterApplied(searchCriteria) ?
          <div>
            <ClearFilters criteriaToApply="all" classes="text-primary badge rounded-pill px-5 mr-3 mb-4 cursor-pointer py-3 bg-gray-15"></ClearFilters>
          </div>
          : null
        }

      </div>
    </>
  )
}

export default FiltersComponent
